module.exports = __webpack_public_path__ + "assets/img/smartTV-module5-9.6f3d7427.jpg";